import {AfterViewInit, Component, ElementRef, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    imports: [CommonModule, FormsModule, TranslateModule],
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => TextInputComponent),
        }
    ]
})
export class TextInputComponent implements ControlValueAccessor, OnInit, AfterViewInit {
  @Input() disabled = false;
  @Input() required = false;
  @Input() label = false;
  @Input() errorMessage = false;
  @Input() isFoucs = false;
  @Input() maxlength = undefined;
  @Input() controlname = '';
  @Input() isInline = true;
  public value: string;
  @ViewChild('textInputElement', {static: false}) textInputElement: ElementRef<HTMLInputElement>;

  constructor() {
  }

  ngOnInit() {
    return;
  }

  ngAfterViewInit() {
    if (this.isFoucs) {
      this.textInputElement.nativeElement.focus();
    }
  }

  public onTouched() {
  }

  public onChange(value: string) {
  }

  writeValue(obj: any): void {
    this.value = obj;
    this.onChange(this.value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


}
